import src from "IMAGE";
export default { src, width: 240, height: 180, blurDataURL: "data:image/webp;base64,UklGRmYAAABXRUJQVlA4TFoAAAAvB0ABAM1VICICHghADgIAAIAbI4DBgGfAANACAAAAAAAAAAAAAAAAAAAAAAwEABiAAgyFYibF8gcAAIiIVFCHNaD2Ne8v2Mr1bAd41v+7B+iCxCSgn5cUJwA=", blurWidth: 8, blurHeight: 6 }
